import { Typography, SvgIcon, SvgIconProps, useTheme } from "@mui/material";

interface StyledIconComponentProps extends SvgIconProps {
  iconSize: { width: string; height: string };
  marginBottom?: string;
}

export function StyledIconComponent({
  iconSize,
  sx,
  marginBottom = "10px",
  ...rest
}: Readonly<StyledIconComponentProps>) {
  const theme = useTheme();

  return (
    <SvgIcon
      {...rest}
      viewBox={`0 0 ${iconSize.width.slice(0, -2)} ${iconSize.height.slice(0, -2)}`}
      sx={{
        width: iconSize.width,
        height: iconSize.height,
        marginBottom,
        "& path": {
          fill: theme.palette.text.primary
        },
        ...sx // allow additional user styles
      }}
    />
  );
}

export const UnselectableText = (title: string) => <Typography>{title}</Typography>;
